import { FormattedMessage } from 'react-intl';

import './TypingText.sass';

const TypingText = () => {
	return (
		<span className="typing-text" role="status">
			<FormattedMessage id="typing-text.thinking" />
		</span>
	);
};

export default TypingText;
